// extracted by mini-css-extract-plugin
export var bird = "birdIcon-module--bird--e7af4 h-full w-auto fill-white";